import { render, staticRenderFns } from "./vipFree.vue?vue&type=template&id=f84194da&scoped=true"
import script from "./vipFree.vue?vue&type=script&lang=js"
export * from "./vipFree.vue?vue&type=script&lang=js"
import style0 from "./vipFree.vue?vue&type=style&index=0&id=f84194da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84194da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f84194da')) {
      api.createRecord('f84194da', component.options)
    } else {
      api.reload('f84194da', component.options)
    }
    module.hot.accept("./vipFree.vue?vue&type=template&id=f84194da&scoped=true", function () {
      api.rerender('f84194da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/vipFree.vue"
export default component.exports